type Props = { message: string | any };

const ErrorText: React.FC<Props> = ({ message }) => <small className="error-text">{message}</small>;

export default ErrorText;
